const PRELOAD_ERROR_RELOAD_AT_KEY = "preloadErrorReloadAt";
export const MIN_INTERVAL_BETWEEN_RELOADS_MS = 60_000;

export const registerPreloadErrorReload = (): void => {
    window.addEventListener("vite:preloadError", () => {
        const lastReloadAt = Number(sessionStorage.getItem(PRELOAD_ERROR_RELOAD_AT_KEY));
        if (Date.now() - lastReloadAt < MIN_INTERVAL_BETWEEN_RELOADS_MS) return;

        sessionStorage.setItem(PRELOAD_ERROR_RELOAD_AT_KEY, String(Date.now()));
        window.location.reload();
    });
};
